module.exports = __webpack_public_path__ + "static/img/service.72c8aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/service.png
// module id = ORxT
// module chunks = 21